export type MonthAttestationReminderLevel = "available" | "normal" | "prominent";

/** Ikke-blokkerende påminnelsesnivå for forrige måneds attestering. */
export function getMonthAttestationReminderLevel(day: number): MonthAttestationReminderLevel {
  if (day >= 6) return "prominent";
  if (day >= 3) return "normal";
  return "available";
}
